import { useTranslation } from 'react-i18next'
import { UpcomingPayroll } from '../../../../../redux/types'
import { PayrollHeader, StatusMessage } from '..'

interface FutureContentProps {
  upcomingPayroll: UpcomingPayroll
}

const FutureContent = ({ upcomingPayroll }: FutureContentProps) => {
  const { t } = useTranslation(['common', 'payrolls'])

  return (
    <>
      <PayrollHeader 
        labelText={t('futurePayday', { ns: 'payrolls' })} 
        paymentDate={upcomingPayroll.paymentDate} 
      />
      <StatusMessage 
        message={t('plentyOfTimeLeftTitle', { ns: 'payrolls' })}
        subMessage={t('plentyOfTimeLeftSubtitle', { ns: 'payrolls' })}
      />
      <div style={{ height: '100%' }}></div>
    </>
  )
}

export default FutureContent 